// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__1KOYB","tooltip__holder":"Tooltip_tooltip__holder__zH3XB","tooltip__text":"Tooltip_tooltip__text__3jdkE"};